import { render, staticRenderFns } from "./CardTicketView.vue?vue&type=template&id=b271f4ca&"
import script from "./CardTicketView.vue?vue&type=script&lang=js&"
export * from "./CardTicketView.vue?vue&type=script&lang=js&"
import style0 from "./CardTicketView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports